import { useProjectBaseActions } from '@store/migrationActions/useProjectBaseActions'

export const useTrialBadge = () => {
  const { saveProject } = useProjectBaseActions()

  // The "project saved under an account" GTM event is fired from
  // saveProjectSaga once the save succeeds and the project becomes owned.
  return () => {
    saveProject()
  }
}
